<template>
    <div>

        <aside>
            <div class="section-data" style="min-height: 400px;">
                <div class="title d-flex justify-content-between">
                    <div class="text">
                        <div id="slot-title">
                        </div>
                        <h3 class="font-blue">Mensajes</h3>
                        <p class="font-gray-dark">Tu listado de conversaciones recientes</p>
                    </div>
                    <div class="tools">
                        <div id="slot-tools">
                        </div>
                    </div>
                </div>
                <div class="data">
                    <div class="container my-3">
                        <div id="slot-content">
                        </div>
                        <div class="content">

                            <div class="target-body" style="">
                                <!-- <ConversationItem /> -->
                                <router-view></router-view>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </aside>

    </div>
</template>
<script>
export default {
    data() {
        return {
            downloading: false
        }
    },
    created() {
        if (!this.$store.getters.accountActivated) {
            this.$router.push({name: 'perfil'})
        }else if (!this.$store.getters.active) {
            this.$router.push({name: 'perfil'})
        }
    }
}
</script>
<style lang="scss">
.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }
    .data {
      .is-empty, .is-loading {
        padding: 45px;
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/#pages/messages/Messages.vue